import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import useRUMView from 'common-datadog/useRUMView';

import Screen from '../Screen';
import Form from '../Form';
import InputFirstName from '../InputNameFirst';
import InputLastName from '../InputNameLast';
import InputEmail from '../InputEmail';
import InputPhone from '../InputPhone';
import InputNewPassword from '../InputNewPassword';
import ButtonPrimary from '../ButtonPrimary';
import ErrorUnauthenticated from '../ErrorUnauthenticated';
import Disclaimers from '../Disclaimers';
import InputConsent from '../InputConsent';
import LegalLink from '../LegalLink';

import usePrefill from '../../resources/prefill';
import useCleanQueryParams from './useCleanQueryParams';
import useForm from './useForm';
import useMerchant from '../../resources/merchant/read';

import { MUST_BE_AUTHENTICATED, LEGAL_DISCLAIMER } from './constants';
import { PHONE_DISCLAIMER, WEBBANK_DISCLAIMER } from '../../constants';
import { getMerchantId } from './utils';

const icon = {
  color: 'info.main',
  position: 'absolute',
  margin: 'auto',
  left: 0,
  right: 0,
  top: -24,
};

const Unauthenticated = () => {
  useCleanQueryParams();
  useRUMView('unauthenticated');
  const { data: prefill } = usePrefill();
  const { data: merchant } = useMerchant(getMerchantId(prefill), { suspense: true });

  const {
    form,
    isLoading,
    handleSubmit,
    error,
  } = useForm();

  if (error === MUST_BE_AUTHENTICATED) {
    return <ErrorUnauthenticated title="An account with the information you provided already exists." view="error_existing_account" />;
  }

  const header = merchant
    ? `${merchant.name} have partnered to provide you with access to financing.`
    : 'Get more time to pay with access to fast, flexible financing.';

  return (
    <Screen
      header={header}
      subheader="Prequalifying is quick, easy, and won't impact your credit score."
    >
      {merchant && <AddIcon sx={icon} />}
      <Form
        noValidate
        form={form}
        handleSubmit={handleSubmit}
      >
        <InputFirstName prefill={prefill?.firstName} />
        <InputLastName prefill={prefill?.lastName} />
        <InputPhone prefill={prefill?.phone} />
        <InputEmail prefill={prefill?.email} />
        <InputNewPassword />
        <InputConsent
          required={false}
          label={(
            <>
              By checking this box, you consent to receive text messages from DigniFi
              regarding customer care support and program notifications. Message
              frequency will vary. Message and data rates may apply. Carriers are not
              liable for delayed or undelivered messages. Reply STOP to opt out, HELP to
              get assistance, or call
              {' '}
              <LegalLink href="tel:+18558085861">(855) 808-5861</LegalLink>
              {' '}
              for customer support.
            </>
          )}
        />
        <Disclaimers>
          {LEGAL_DISCLAIMER}
        </Disclaimers>
        <ButtonPrimary isLoading={isLoading}>
          Create Account
        </ButtonPrimary>
      </Form>
      <Disclaimers>
        {WEBBANK_DISCLAIMER}
        {PHONE_DISCLAIMER}
      </Disclaimers>
    </Screen>
  );
};

export default Unauthenticated;
